import { IMobileAccess, IProduct } from "../../fetchOrderProducts";

export function isMobileAccess(product: IProduct): product is IMobileAccess {
  return (
    "specificationId" in product && product.specificationId === "MOBILE_ACCESS"
  );
}
